var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "-mt-12 sm-md:mt-0"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "text-lg mb-6"
  }, [_vm._v("\n\t\t\t\tKeep your membership active by adding a backup card. This will help make sure that you can\n\t\t\t\tcontinue building credit with Extra.\n\t\t\t")]), _vm._v(" "), _c('h4', {
    staticClass: "mb-6 mt-12 sm-md:mt-8"
  }, [_vm._v("Backup card")]), _vm._v(" "), _vm.validationError && _vm.validationError.message ? _c('div', {
    staticClass: "warn-card py-4 px-5 rounded-xl"
  }, [_c('p', {
    staticClass: "font-medium"
  }, [_vm._v(_vm._s(_vm.validationError.message))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my-6 mb-12 sm-md:mb-8",
    attrs: {
      "id": "stripe-target"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-start mt-4 space-x-4 space-y-4 sm:flex-col sm-md:space-x-0 sm-md:space-y-4"
  }, [_c('button', {
    staticClass: "button--filled button--mint mt-4 min-w-16 sm:w-full h-12",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n\t\t\t\t\tSubmit\n\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button--gray mt-4 sm:w-full h-12",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSkip
    }
  }, [_vm._v("\n\t\t\t\t\tSkip for now\n\t\t\t\t")])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h1', {
    staticClass: "mb-8 sm-md:mb-6 sm-md:-mt-6"
  }, [_vm._v("\n\t\t\t\tCongrats, you're officially an "), _c('br', {
    staticClass: "sm-md:hidden"
  }), _vm._v("\n\t\t\t\tExtra Member. Time to add a backup card.\n\t\t\t")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mb-6 mt-12 sm-md:mt-8 space-y-5 policies"
  }, [_c('div', {
    staticClass: "mb-4 text-md leading-5 color--dark--grey"
  }, [_vm._v("\n\t\t\t\t\tBy clicking “Submit”, you are authorizing Extra to charge your credit card above for\n\t\t\t\t\tyour membership fees each month in which the ACH debit attempt fails.\n\t\t\t\t")])]);
}];
export { render, staticRenderFns };